(function () {
  'use strict';

  function initAuraaRitual(section) {
    if (!section || section.dataset.auraaRitualReady === 'true') return;
    section.dataset.auraaRitualReady = 'true';

    var items = section.querySelectorAll('[data-auraa-reveal]');

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -8% 0px'
    });

    items.forEach(function (item, index) {
      item.style.transitionDelay = Math.min(index * 70, 280) + 'ms';
      observer.observe(item);
    });
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-auraa-ritual]').forEach(initAuraaRitual);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();